import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ORDER_DETAILS_ROUTE } from '../shared/constants/routes';
import { AuthGuard } from '../guards/auth.guard';
import { OrderDetailsComponent } from './order-details/order-details.component';

const routes: Routes = [
  {
    path: `${ORDER_DETAILS_ROUTE}/:store_id/:order_id`,
    component: OrderDetailsComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrderDetailsRoutingModule {}
